/* eslint-disable @next/next/no-img-element */

import React, { useMemo } from 'react';

import Loader from '../Loader';
import { formatCurrency, formatCurrency2Digits } from '../../helper/vehicle_formatter';


import styles from './styles.module.scss';
import moment from 'moment';

interface IOptionPreview {
  make: string;
  model: string;
  image: string;
  price?: number;
  trim_level?: string;
  isFinance?: boolean;
  financeData?: any;
  commercial?: boolean;
  isBoiWebsite?: boolean;
}

const OptionPreview = ({ 
  make, model, trim_level, image, price,
  isFinance, financeData, 
  commercial = false, isBoiWebsite = false
} : IOptionPreview) => {
  const financeAvailable = useMemo(() => {
    return isFinance && (Object.keys(financeData).length);
  }, [financeData, isFinance])

  const financeInfo = useMemo(() => {
    if (!financeAvailable || price === undefined) return '';

    const currentDate = moment(new Date()).format('DD.MM.YYYY')

    const monthlyPayments = financeData.term_in_month ? financeData.term_in_month - 1 : 'TBC';

    const aprValue = parseFloat(financeData?.apr);
    const aprDisplay = isNaN(aprValue)
        ? 'TBC'
        : aprValue < 0.01
            ? '€0'
            : `€${(aprValue * 100).toFixed(2)}`;


      return `${make} ${model}: Retail Price† ${formatCurrency(price)}. Customer Deposit / Trade In ${formatCurrency2Digits(financeData.deposit_amount)}. Finance Amount ${formatCurrency(financeData.finance_amount)}. ${monthlyPayments} monthly payments of ${formatCurrency2Digits(financeData.monthly_cost)}. Total Cost of Credit ${formatCurrency(financeData.cost_of_credit)}. GMFV†† (Optional Final Payment) ${formatCurrency2Digits(financeData.gfv)}. Fixed APR ${aprDisplay}%* (Annual Percentage Rate) as at ${currentDate}. Figures are indicative and the quotation is for illustrative purposes only and does not constitute a contract. Full terms and conditions are available at the bottom of this page.`
    }, [financeAvailable, make, model, price, financeData])

  return (
    <div className={`${styles.vehicleHolder} ${isBoiWebsite ? styles.boi : styles.nevo} ${isFinance && styles.financeHolder}`}>
      <div className={styles.biggerBox}>
        <div className={styles.vehicleContent}>
          <p className={styles.vehicleMake}>{ make }</p>
          <p className={styles.vehicleModel}>{ model }</p>
          
          { !!trim_level && 
            <p className={styles.vehicleTrim}>{ trim_level }</p>
          }

          {(financeAvailable && price !== undefined) && (
            <>
              <p className={`${styles.financeHeader} ${styles.financePrice}`}>
                Personal Contract Plan (PCP)
              </p>
              <p className={styles.financePrice}>
                { formatCurrency(financeData.monthly_cost) } per Month
              </p>

              <p className={`${styles.financeHeader} ${styles.financePrice}`}>
                RRP
              </p>
              <p className={styles.financePrice}>
                { formatCurrency(price) } Price
              </p>

              <p className={`${styles.financeMobile} ${styles.financeInfo}`}>
                { financeInfo }
              </p>
            </>
          )}
        </div>
        

        { image === "" 
          ? <Loader />
          : image === 'no-image' ? <></> : 

          <article className={styles.imageHolder}>
            <img src={image} alt="car image" className={styles.image} />
          </article>
        }

      </div>

      { financeAvailable && (
        <p className={`${styles.financeDesktop} ${styles.financeInfo}`}>
          { financeInfo }
        </p>
      )}
    </div>
  )
}

export default OptionPreview;